const Loader = () => {
  return (
    <div className="loader-container absolute w-[100px] h-[100px] rounded-full border-[2px] border-[#00000033] bg-[#D9D9D9]">
      <div className="w-[38px] h-[38px] light-bg border-sangati-green border-4 absolute top-2 left-2 rounded-tl-full"></div>

      <div className="w-[38px] h-[38px] dark-bg border-sangati-green border-4 absolute top-2 right-2 rounded-tr-full"></div>

      <div className="w-[38px] h-[38px] light-bg border-sangati-green border-4 absolute bottom-2 left-2 rounded-bl-full"></div>

      <div className="w-[38px] h-[38px] dark-bg border-sangati-green border-4 absolute bottom-2 right-2 rounded-br-full"></div>
    </div>
  );
};

export default Loader;
